/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUsersByRoleQueryResult } from '../../models/get-users-by-role-query-result';

export interface ApiCommonDashboardGetUsersPost$Plain$Params {
  Role?: string;
  StackholderId?: number;
}

export function apiCommonDashboardGetUsersPost$Plain(http: HttpClient, rootUrl: string, params?: ApiCommonDashboardGetUsersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUsersByRoleQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiCommonDashboardGetUsersPost$Plain.PATH, 'post');
  if (params) {
    rb.query('Role', params.Role, {});
    rb.query('StackholderId', params.StackholderId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUsersByRoleQueryResult>;
    })
  );
}

apiCommonDashboardGetUsersPost$Plain.PATH = '/api/Common/Dashboard/GetUsers';
